var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.disabled ? 'span' : 'router-link',{tag:"component",class:_vm.logoStyle,attrs:{"to":{ name: _vm.isLoggedIn ? 'ContractList' : 'Login' }}},[_c('img',{attrs:{"src":_vm.$cdnEndpoint + 'img/logo/' + _vm.fileName,"alt":"LeCheck"}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-817e1874","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/_atoms/Logo.vue
// module id = null
// module chunks = 